import { validate as validateUuid } from 'uuid'

import type { ControllerListIdentifier } from '@/features/controller/types'

const ID_SEPARATOR_REGEX = /[^\w-]+/

export interface ControllerListIdentifiersParseResult {
  validIdentifiers: ControllerListIdentifier[]
  invalidIdentifiers: string[]
}

/** The entries of the given text in their order, invalid ones included */
export function splitControllerListText(input: string): string[] {
  return input
    .trim()
    .split(ID_SEPARATOR_REGEX)
    .filter((item) => item.length > 0)
}

export function parseControllerListIdentifiers(input: string): ControllerListIdentifiersParseResult {
  // Each entry once, so a controller entered twice doesn't get two rows
  const items = new Set(splitControllerListText(input))

  const validIdentifiers: ControllerListIdentifier[] = []
  const invalidIdentifiers: string[] = []

  for (const item of items) {
    if (validateUuid(item)) {
      validIdentifiers.push({ rawValue: item, id: item })
    } else {
      const number = Number.parseInt(item, 10)
      if (number === undefined || Number.isNaN(number) || number.toString().length !== item.length) {
        invalidIdentifiers.push(item)
      } else {
        validIdentifiers.push({ rawValue: item, equipmentNumber: number })
      }
    }
  }

  return {
    validIdentifiers,
    invalidIdentifiers,
  }
}
